import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import MainPageLayout from "../../../layout/MainPageLayout";
import useGetHistory from "../../../CustomHooks/useAxios/useGetHistory";
import { CYLINDER_TRANSIT } from "../../../api/allApi_List";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import LoadingDisplay from "../../../components/UI/LoadingDisplay";
import { endDate, getDateBefore } from "../../../helpers/dateHelpers";
import { TransitSummaryCards } from "../components/transit/TransitSummaryCards";
import { TransitTable } from "../components/transit/TransitTable";
import DialogBox from "../../../components/UI/DialogBox";
import { setError } from "../../../redux/dataSlice";
import { DateFilters } from "../../../components/Filter/dateFilters/DateFilters";

const CylinderTransitPage = () => {
  const [dateRange, setDateRange] = useState({
    start: "",
    end: "",
    currentSelector: "lastMonth",
  });
  const fromDate = getDateBefore(30);
  const { getHistory, historyLoaded, isSucceed } = useGetHistory();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.data.data);
  const historyError = useSelector((state) => state.data.error);
  const historyErrMsg = useSelector((state) => state.data.errMessage);
  const dataLength = !historyLoaded && !historyError ? data.length : 0;

  useEffect(() => {
    getHistory(`${CYLINDER_TRANSIT}/${fromDate}/${endDate}`);
  }, []);

  return (
    <MainPageLayout
      headerConfig={{ title: "Cylinders In Transit" }}
      numberOfData={dataLength}
      bgColor="bg-[#f0f2f7]"
    >
      <DateFilters
        dateRange={dateRange}
        setDateRange={setDateRange}
        getHistory={getHistory}
        baseUrl={CYLINDER_TRANSIT}
        loaded={historyLoaded}
      />
      {historyLoaded ? (
        <LoadingDisplay height="h-[80vh] mt-2" />
      ) : (
        isSucceed && (
          <>
            <TransitSummaryCards />
            <TransitTable />
          </>
        )
      )}
      {historyError && (
        <DialogBox
          title="Error"
          btnText="Ok"
          message={handleErrMessage(historyErrMsg)}
          closeAction={() => dispatch(setError("false"))}
        />
      )}
    </MainPageLayout>
  );
};

export default CylinderTransitPage;
